function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPresspauseBro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-267"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M426.59,67.12C404.33,49,376.92,39.41,348.45,34.43c-22.47-3.94-45.39-5-68.16-4.27C176.54,33.62,144.83,85.5,119.47,91.84,49.53,109.33,13.87,174.12,8.36,241.61c-.15,1.82-.29,3.64-.41,5.46C5.44,284.74,6.79,323.43,22,358.59c12.94,29.87,36.57,52.08,65.17,67,66.29,34.59,134.88,23.06,174.66,6.34s35.16-25.36,88.77-10.37S451.49,402,468.78,361.61,510.3,233,482.62,155.25C472.56,127,458.6,98.89,437.34,77A124,124,0,0,0,426.59,67.12Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.59,67.12C404.33,49,376.92,39.41,348.45,34.43c-22.47-3.94-45.39-5-68.16-4.27C176.54,33.62,144.83,85.5,119.47,91.84,49.53,109.33,13.87,174.12,8.36,241.61c-.15,1.82-.29,3.64-.41,5.46C5.44,284.74,6.79,323.43,22,358.59c12.94,29.87,36.57,52.08,65.17,67,66.29,34.59,134.88,23.06,174.66,6.34s35.16-25.36,88.77-10.37S451.49,402,468.78,361.61,510.3,233,482.62,155.25C472.56,127,458.6,98.89,437.34,77A124,124,0,0,0,426.59,67.12Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-267"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 337.52,
    y1: 467.41,
    x2: 459.64,
    y2: 467.41,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40.28,
    y1: 467.41,
    x2: 329.03,
    y2: 467.41,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Graphics--inject-267"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("line", {
    x1: 457.1,
    y1: 156.23,
    x2: 471.37,
    y2: 170.5,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 471.37,
    y1: 156.23,
    x2: 457.1,
    y2: 170.5,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("line", {
    x1: 65.97,
    y1: 416.98,
    x2: 80.24,
    y2: 431.25,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.24,
    y1: 416.98,
    x2: 65.97,
    y2: 431.25,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("line", {
    x1: 28.17,
    y1: 256.52,
    x2: 42.44,
    y2: 270.79,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42.44,
    y1: 256.52,
    x2: 28.17,
    y2: 270.79,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("line", {
    x1: 298.18,
    y1: 276.58,
    x2: 312.45,
    y2: 290.85,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 312.45,
    y1: 276.58,
    x2: 298.18,
    y2: 290.85,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M462.5,222.57a4.63,4.63,0,1,0-4.63,4.63A4.64,4.64,0,0,0,462.5,222.57Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.17,308.2a4.63,4.63,0,1,0-4.63,4.63A4.62,4.62,0,0,0,82.17,308.2Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.85,431.93a4.63,4.63,0,1,0-4.63,4.63A4.63,4.63,0,0,0,261.85,431.93Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.28,170.89a4.63,4.63,0,1,0-4.63,4.62A4.63,4.63,0,0,0,41.28,170.89Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3,
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Icons--inject-267"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 182.46,
    y: 298.09,
    width: 37.69,
    height: 93.61,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.82,
    y: 298.09,
    width: 37.69,
    height: 93.61,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "72.97 362.59 104.91 344.15 104.91 381.03 72.97 362.59",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.9 362.59 137.84 344.15 137.84 381.03 105.9 362.59",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "388 362.59 356.05 344.15 356.05 381.03 388 362.59",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.06 362.59 323.12 344.15 323.12 381.03 355.06 362.59",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M330.34,430a4.55,4.55,0,0,0,2.28-5.94l-9-21A3.58,3.58,0,0,0,319,401a3.55,3.55,0,0,0-2.27,2.63l0-.1a3.58,3.58,0,0,0-7,1.1,3.59,3.59,0,0,0-5.95,2.94l-7.23-16.18a3.59,3.59,0,1,0-6.64,2.72l13.82,32.25-11.43-5.77a3.59,3.59,0,1,0-3.23,6.41l19.06,10.49a6.22,6.22,0,0,0,3,.77C311.46,438.22,324.11,432.89,330.34,430Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-267"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.14,41.86h-36.5v3.3H86.91A28.81,28.81,0,0,0,58.1,74V228.69A28.81,28.81,0,0,0,86.91,257.5H401.3a28.81,28.81,0,0,0,28.8-28.81V74a28.81,28.81,0,0,0-28.8-28.81h-200v-3.3H179.68v3.3h-9.54Z",
    style: {
      fill: "#707070",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.27,
    y: -30.7,
    width: 205.67,
    height: 364.06,
    rx: 30.52,
    transform: "translate(92.77 395.43) rotate(-90)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.69,83v57.12l.21.06c6.3,1.69,10.4,5.58,10.4,9.89v2.48c0,4.31-4.1,8.2-10.4,9.89l-.21.06v57.12c0,15.91,13.35,28.8,29.83,28.8H392c16.48,0,29.83-12.89,29.83-28.8V83c0-15.91-13.35-28.81-29.83-28.81H94.52C78,54.21,64.69,67.11,64.69,83Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 369.07,
    y1: 186.04,
    x2: 410.75,
    y2: 186.04,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 219.26,
    y1: 186.04,
    x2: 362.42,
    y2: 186.04,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72.47,
    y1: 186.04,
    x2: 208.39,
    y2: 186.04,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("line", {
    x1: 400.08,
    y1: 167.73,
    x2: 412.96,
    y2: 180.3,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "202.76 119.86 274.83 171.5 343.48 112.5 394.56 162.35",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "72.76 172.82 177.13 101.51 197.73 116.27",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.89,91.11h26.68s.71-9.17-8.47-11.29c-7.16-1.65-16.05,4.29-22.07-.66l-.15-.13c-2.65-2.29-4.28-5.5-6.41-8.28A24.79,24.79,0,0,0,313.26,61c-7.11-.28-14.39,3.27-18.07,9.36-1,1.66-1.87,3.6-3.62,4.42-3.31,1.56-6.64-1.82-10-3.33-10.6-4.8-11.81,6.33-17.16,11.34s-13.2-2.36-18.71,1.31a15.2,15.2,0,0,0-5.65,7.06H334",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.94,83.3a12.65,12.65,0,0,0-5.58-1.6,11.27,11.27,0,0,0-10,5.16,5.6,5.6,0,0,1-2,2.44c-1.83.85-3.66-1-5.49-1.84-5.84-2.65-6.51,3.49-9.46,6.25s-7.27-1.3-10.3.72A8.39,8.39,0,0,0,91,98.32h70.78s.39-5.06-4.66-6.22c-3.95-.91-8.85,2.36-12.16-.37a.27.27,0,0,1-.08-.07c-1.46-1.26-2.36-3-3.54-4.56",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 99.24,
    y: 224.12,
    width: 288.05,
    height: 7.36,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.24,
    y: 224.12,
    width: 175.36,
    height: 7.36,
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.82,227.8a4.82,4.82,0,1,0-4.81,4.82A4.81,4.81,0,0,0,281.82,227.8Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.07,
    cy: 151.92,
    r: 2.7,
    style: {
      fill: "#707070"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.46 140.8 312.77 126.55 312.77 155.06 337.46 140.8",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.28,
    y: 125.26,
    width: 6.66,
    height: 31.09,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "149.06 140.8 173.76 126.55 173.76 155.06 149.06 140.8",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.59,
    y: 125.26,
    width: 6.66,
    height: 31.09,
    transform: "translate(281.84 281.61) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Button--inject-267"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 243.26,
    cy: 141.02,
    r: 23.46,
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.93,
    y: 128.02,
    width: 10.47,
    height: 26,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.13,
    y: 128.02,
    width: 10.47,
    height: 26,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-267"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.09,188.76s6.81,3.71,7.43,6.8.3,7.12,1.23,8.05,5.11.31,4.8,3.25a11.64,11.64,0,0,1-1.39,4.64s-.16,4.33-.47,7.88,0,5-2,5.88-9.13.16-10.21.31-3.09-4.95-4.48-15.93S177,187.68,180.09,188.76Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.91,324.2l-6.19,8.67s-8.35.31-11,.77-3.09,1.55-3.09,2.94-.31,4.48-.31,5.88a3.14,3.14,0,0,0,2.94,2.78c1.54.15,2.94.46,3.71-.15a10.06,10.06,0,0,0,1.7-2.48s2.79,1.24,6-1.39A49.42,49.42,0,0,0,109.6,336c.93-1.08,7.74-7.12,7.74-7.12Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.69,342.61s-3.71.77-4.64-.46",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.38,319.79s-6.78,18.36-6.12,25.79,1.31,17.93,1.53,27.11.43,27.1.43,27.1-2.84,9.62-3.49,14.65-.44,45.6-.44,45.6-3.06,7.87-5,10.71-4.81,5-7,7-1.32,4.81,2.62,5.46,8.52.22,10.49-.87,6.12-2,7.65-5.47.88-15.3.88-15.3,9-34.24,10.49-44.07,3.71-24.92,3.93-26.67,9-40.22,9-40.22l4.37-.44,3.93,17.93,5,33.44s-1.31,13.55.22,22.95,2.62,45.82,2.62,45.82-1.75,11.59-1.09,13.34,3.71,2,8.3,1.75a25.48,25.48,0,0,0,10.93-3.5,3.58,3.58,0,0,0,1.53-4.81c-.87-2-3.06-3.72-4.37-5.9s-2.62-3.28-3.06-5.25,3.72-39,3.06-46.91-.87-18.36-.87-18.36,5-17.93,5.24-36.51,2.41-21.2-2.18-33.22-7.22-16.4-7.22-16.4l-50.27,1.31Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.77,419c-.65-7.87-.87-18.36-.87-18.36s5-17.93,5.24-36.51,2.41-21.2-2.18-33.22-7.22-16.4-7.22-16.4l-50.27,1.31-1.09,3.94s-6.78,18.36-6.12,25.79,1.31,17.93,1.53,27.11.43,27.1.43,27.1-2.84,9.62-3.49,14.65c-.41,3.12-.48,25.39-.48,35.11a12.07,12.07,0,0,1,12.57,1.07c2.64-8.05,6.73-27.64,7.58-33.12,1.53-9.84,3.71-24.92,3.93-26.67s9-40.22,9-40.22l4.37-.44,3.93,17.93,5,33.44s-1.31,13.55.22,22.95c.94,5.76,1.71,27.21,2.17,36.08a14.37,14.37,0,0,0,13.21-1.49C203.23,449.7,205.24,424.68,204.77,419Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.77,471.19c-.66-1.11-1.33-1.94-1.88-2.75-.24.58-.55,1.34-1,2.31a3.06,3.06,0,0,1-3.28,2.19s-3.71-3.28-6.34-3.5-2.84.87-2.84.87-1.75,11.59-1.09,13.34,3.71,2,8.3,1.75a25.48,25.48,0,0,0,10.93-3.5,3.58,3.58,0,0,0,1.53-4.81C208.27,475.12,206.08,473.37,204.77,471.19Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.44,464.41a19,19,0,0,0-5,5,17.73,17.73,0,0,0-1.14-4.57,40.53,40.53,0,0,1-3,5.88c-2,2.84-4.81,5-7,7s-1.32,4.81,2.62,5.46,8.52.22,10.49-.87,6.12-2,7.65-5.47c1.11-2.53,1.07-9.43,1-13l-.53.15S147.5,462.44,144.44,464.41Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.44,474.9c-5,.88-7.87,3.94-11.8,5.47-1.72.67-3.24,1.3-4.39,1.79a5.86,5.86,0,0,0,2.64,1c3.93.66,8.52.22,10.49-.87s6.12-2,7.65-5.47C149,476.87,149.47,474,144.44,474.9Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.76,317.76s-1.39,2.94,0,4.64,14.85,7.11,31.09,4.17,18.25-3.71,21-7.89,1.55-6.8.77-8.81,8.82,6.19-17.94,8.35S149,314.51,149,314.51Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.75,194.07s1.18-11,1.18-11.53a37.38,37.38,0,0,0-2.71-5.76c-1-1.87-1.36-3.56-2.37-5.76s-4.92-1.87-3-3.56,3-1.53,4.4-.68,2.38,2,3.73,1.35,3.73-11.35,4.07-12.71,2.71-1.69,3.05,0-.84,10-.84,10,2.54-1.35,3.56-.68a3.73,3.73,0,0,1,1.35,1.87s2,1,2.2,2.2l.17,1.19s1.36,2,1.19,3.39a32.26,32.26,0,0,1-2.37,7.46c-1.36,3.05-3.56,7.29-4.07,8.64a62.7,62.7,0,0,0-1.19,7.29Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.79,230.68s8.05,5.1,9.13,4.48,7.11-4.79,11.75-6,5.88-1.7,7-2.79,15.32-12.68,16.09-13.76,8.51-22.27,8.51-22.27,3.86-.16,5.57.61a12.24,12.24,0,0,1,3.09,2.17s-2.63,25.52-3.09,27.07-6.35,7.73-9.59,11.44-27.23,21-28.31,23.05-6.5,20.88-7.42,26.45,6.49,22.74,6.65,25.68,1.08,6.8-1.24,9.43-8,5.88-29.7,7.12-23.35-5.11-23.35-7.43,1.7-12.22,1.08-19.18a99,99,0,0,0-1.7-11.75s-5.26,13-6.65,15.31-7,13.76-10.52,17.79-9.55,13.71-13.42,13.25-6-3.4-6-5.41a21.94,21.94,0,0,1,1.08-5.26s14-25.17,15.27-27.8,5.11-16.08,6.19-21.65.77-17.94,2.94-21.35,19.8-10.82,24.28-13.61S175.14,229.75,181.79,230.68Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "140.08 271.49 146.22 284.97 137.84 273.98",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "194.39 262.02 201.9 254.65 192.65 270",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.94,294.66s-13.2,17.44-23.67,21.92",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171,299.64s-11,11.71-13.2,13.46",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158,189.22a21.72,21.72,0,0,0-7.58,9.44c-2.16,5.88-1.23,13.76-1.39,14.54s-16.24,1.39-17.48,7.27,3.56,10.21,4.33,13-9.9,4.64-11.44,11.91,16.39,7.89,15.62,12.37-2.47,3.87-2,8.51,6.19,6.81,13,9,6.5,3.71,10.67.31,4.49-6.19,5.26-9.43,1.7-.78,7-5.11,6.65-11,6.19-14.07-.15.77,3.71-4.8,2.17-8.2-.31-13.46-3.55-7.27-3.24-10.82,4.64-15.16,2.47-19.49-3.56-4-2.47-6.81,3.71-3.4.46-7.11-8.51-3.87-10.83-2.48-.93,1.7-4.79,2.79A18.41,18.41,0,0,0,158,189.22Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.75,214.05c0,4.57-2.8,8.27-6.26,8.27s-6.27-3.7-6.27-8.27,2.81-8.28,6.27-8.28S188.75,209.48,188.75,214.05Z",
    style: {
      fill: "#787878",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.09,214.05c0,3.46-2.13,6.27-4.75,6.27s-4.74-2.81-4.74-6.27,2.12-6.27,4.74-6.27S189.09,210.59,189.09,214.05Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.63,201.35a24.3,24.3,0,0,0-6.38-12.61c-3.55-3.56-9.47-5.11-15.07-4-4.3.88-6.44,2.74-7.68,5.83-.18.46-1.19,1.36-1,1.78-.47-1.13,6.21-4.32,6.94-4.56a13.88,13.88,0,0,1,14.32,3.42,21,21,0,0,1,5.38,10.6,1.77,1.77,0,0,0,1.75,1.52h.25A1.78,1.78,0,0,0,184.63,201.35Z",
    style: {
      fill: "#787878",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,213.06a3.12,3.12,0,0,1-3.08-2.73,65.94,65.94,0,0,0-1.71-8.49,3.11,3.11,0,0,1,6-1.67,71.41,71.41,0,0,1,1.89,9.4,3.1,3.1,0,0,1-2.7,3.46A2.56,2.56,0,0,1,184,213.06Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-267"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 401.72,
    y1: 308.04,
    x2: 414.92,
    y2: 434.54,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 412.32,
    y1: 409.81,
    x2: 406.81,
    y2: 404.01,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.63,405.91a6.79,6.79,0,0,0-2.38-5.08c-1.54-1.37-9.62-4.77-10.39-1.93C395,402,403.3,408.08,408.63,405.91Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 408.63,
    y1: 405.91,
    x2: 400.93,
    y2: 401.11,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 413.69,
    y1: 422.87,
    x2: 408.31,
    y2: 418.4,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.13,420.29a6.77,6.77,0,0,0-2.38-5.07c-1.54-1.38-9.62-4.78-10.39-1.93C396.53,416.39,404.8,422.47,410.13,420.29Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.13,
    y1: 420.29,
    x2: 402.43,
    y2: 415.5,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 408.58,
    y1: 373.79,
    x2: 403.15,
    y2: 368.9,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405,370.8a6.78,6.78,0,0,0-2.39-5.08c-1.53-1.37-9.62-4.77-10.39-1.92C391.36,366.89,399.64,373,405,370.8Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 404.97,
    y1: 370.8,
    x2: 397.27,
    y2: 366,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.1,
    y1: 389.09,
    x2: 404.65,
    y2: 383.29,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.47,385.19a6.78,6.78,0,0,0-2.39-5.08c-1.53-1.37-9.62-4.77-10.38-1.93C392.86,381.28,401.14,387.36,406.47,385.19Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 406.47,
    y1: 385.19,
    x2: 398.77,
    y2: 380.39,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 406.16,
    y1: 351.09,
    x2: 400.71,
    y2: 345.53,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.53,347.43a6.78,6.78,0,0,0-2.39-5.08c-1.53-1.37-9.62-4.77-10.38-1.92C388.92,343.52,397.2,349.6,402.53,347.43Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 402.53,
    y1: 347.43,
    x2: 394.83,
    y2: 342.63,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.53,
    y1: 326.1,
    x2: 398.26,
    y2: 322.06,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.08,324a6.76,6.76,0,0,0-2.39-5.07c-1.53-1.37-9.62-4.78-10.38-1.93C386.47,320.05,394.75,326.13,400.08,324Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400.08,
    y1: 323.95,
    x2: 392.38,
    y2: 319.16,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 411.79,
    y1: 401.82,
    x2: 416.34,
    y2: 394.4,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415,396.63a6.79,6.79,0,0,1,1.29-5.46c1.21-1.66,8.42-6.66,9.76-4C427.46,390,420.62,397.66,415,396.63Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 414.95,
    y1: 396.63,
    x2: 420.37,
    y2: 391.55,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 407.84,
    y1: 363.96,
    x2: 412.39,
    y2: 356.54,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411,358.77a6.81,6.81,0,0,1,1.28-5.46c1.22-1.66,6.86-5.82,8.2-3.19C421.94,353,416.67,359.8,411,358.77Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 411,
    y1: 358.77,
    x2: 417.93,
    y2: 352.14,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 406.1,
    y1: 347.32,
    x2: 410.65,
    y2: 339.9,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.26,342.13a6.79,6.79,0,0,1,1.29-5.46c1.22-1.66,8.43-6.66,9.76-4C421.77,335.5,414.93,343.16,409.26,342.13Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 409.26,
    y1: 342.13,
    x2: 416.2,
    y2: 335.51,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.56,
    y1: 322.93,
    x2: 408.11,
    y2: 315.51,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.72,317.74a6.76,6.76,0,0,1,1.28-5.46c1.22-1.66,8.43-6.66,9.77-4C419.23,311.11,412.38,318.77,406.72,317.74Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 406.72,
    y1: 317.74,
    x2: 413.65,
    y2: 311.11,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.61,307.34a6.81,6.81,0,0,1,1.28-5.46c1.22-1.66,8.43-6.66,9.77-4C414.12,300.71,407.27,308.37,401.61,307.34Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 401.61,
    y1: 307.34,
    x2: 408.54,
    y2: 300.71,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402,307.62a6.75,6.75,0,0,1-5.29-1.85c-1.53-1.38-5.74-9.08-3-10.13C396.73,294.49,403.63,302.1,402,307.62Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 402.01,
    y1: 307.62,
    x2: 396.15,
    y2: 300.03,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 421.5,
    y1: 273.94,
    x2: 421.5,
    y2: 433.93,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 436.54,
    y1: 325.46,
    x2: 423.41,
    y2: 451.97,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 426.19,
    y1: 426.13,
    x2: 423.15,
    y2: 422.65,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.15,422.65a6.81,6.81,0,0,0-1.28-5.46c-1.23-1.65-8.44-6.65-9.77-4C410.64,416,417.49,423.69,423.15,422.65Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 423.15,
    y1: 422.65,
    x2: 416.61,
    y2: 416.37,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 429.9,
    y1: 390.01,
    x2: 425.39,
    y2: 386.24,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.79,387.54a6.74,6.74,0,0,0-1.28-5.45c-1.22-1.66-8.43-6.66-9.77-4C414.29,380.92,421.13,388.58,426.79,387.54Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 426.79,
    y1: 387.54,
    x2: 420.25,
    y2: 381.26,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 428.47,
    y1: 407.12,
    x2: 423.91,
    y2: 399.7,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.3,401.93a6.76,6.76,0,0,0-1.28-5.46c-1.22-1.66-8.44-6.65-9.77-4C412.79,395.31,419.64,403,425.3,401.93Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 425.3,
    y1: 401.93,
    x2: 418.76,
    y2: 395.65,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 432.18,
    y1: 366.95,
    x2: 427.83,
    y2: 361.94,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.22,364.17a6.79,6.79,0,0,0-1.29-5.46c-1.22-1.66-8.43-6.65-9.77-4C416.71,357.55,423.56,365.2,429.22,364.17Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 429.22,
    y1: 364.17,
    x2: 422.68,
    y2: 357.89,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 434.46,
    y1: 344.99,
    x2: 430.27,
    y2: 338.47,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.66,340.7a6.79,6.79,0,0,0-1.29-5.46c-1.22-1.66-8.43-6.65-9.77-4C419.15,334.07,426,341.73,431.66,340.7Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 431.66,
    y1: 340.7,
    x2: 425.11,
    y2: 334.42,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 427.09,
    y1: 419.31,
    x2: 433.07,
    y2: 412.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.25,414.88a6.79,6.79,0,0,1,2.38-5.08c1.53-1.37,9.62-4.78,10.39-1.93C444.85,411,436.58,417.05,431.25,414.88Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 431.25,
    y1: 414.88,
    x2: 439.4,
    y2: 409.82,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 431.01,
    y1: 381.44,
    x2: 437,
    y2: 375.12,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.18,377a6.77,6.77,0,0,1,2.38-5.07c1.53-1.38,9.62-4.78,10.39-1.94C448.78,373.1,440.51,379.19,435.18,377Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 435.18,
    y1: 377.01,
    x2: 443.32,
    y2: 371.96,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 432.74,
    y1: 364.8,
    x2: 438.72,
    y2: 358.48,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.91,360.38a6.76,6.76,0,0,1,2.37-5.08c1.54-1.38,9.62-4.78,10.39-1.94C450.51,356.46,442.24,362.55,436.91,360.38Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 436.91,
    y1: 360.38,
    x2: 445.05,
    y2: 355.32,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 435.2,
    y1: 339.16,
    x2: 441.25,
    y2: 334.09,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.44,336a6.76,6.76,0,0,1,2.38-5.08c1.53-1.37,9.61-4.78,10.38-1.93C453,332.07,444.77,338.16,439.44,336Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 439.44,
    y1: 335.98,
    x2: 447.58,
    y2: 330.93,
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.58,324.75a6.79,6.79,0,0,1,2.38-5.08c1.53-1.37,9.62-4.78,10.39-1.93C450.18,320.84,441.91,326.92,436.58,324.75Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 436.58,
    y1: 324.75,
    x2: 444.72,
    y2: 319.69,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.91,325.11a6.77,6.77,0,0,1-4.8-2.9c-1.2-1.67-3.74-10.06-.83-10.53C434.45,311.17,439.63,320,436.91,325.11Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 436.91,
    y1: 325.11,
    x2: 432.74,
    y2: 316.48,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 421.28,
    y1: 409.58,
    x2: 416.33,
    y2: 402.96,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.94,405a6.79,6.79,0,0,0-1.84-5.3c-1.39-1.52-9.07-5.75-10.13-3C404.82,399.74,412.41,406.65,417.94,405Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 417.94,
    y1: 405.04,
    x2: 410.78,
    y2: 399.47,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 421.45,
    y1: 377.67,
    x2: 416.33,
    y2: 372.9,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.94,375a6.79,6.79,0,0,0-1.84-5.3c-1.39-1.52-9.07-5.74-10.13-3C404.82,369.67,412.41,376.58,417.94,375Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 417.94,
    y1: 374.97,
    x2: 410.78,
    y2: 369.4,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 421.63,
    y1: 344.51,
    x2: 416.33,
    y2: 337.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.94,339.67a6.77,6.77,0,0,0-1.84-5.29c-1.39-1.53-9.07-5.75-10.13-3C404.82,334.38,412.41,341.29,417.94,339.67Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 417.94,
    y1: 339.67,
    x2: 410.78,
    y2: 334.1,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 421.28,
    y1: 318.57,
    x2: 416.33,
    y2: 314.1,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.94,316.18a6.79,6.79,0,0,0-1.84-5.3c-1.39-1.53-9.07-5.75-10.13-3C404.82,310.88,412.41,317.79,417.94,316.18Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 417.94,
    y1: 316.18,
    x2: 410.78,
    y2: 310.61,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 421.57,
    y1: 295.06,
    x2: 416.43,
    y2: 291.29,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.94,292.57a6.77,6.77,0,0,0-1.84-5.29c-1.39-1.53-9.07-5.75-10.13-3C404.82,287.28,412.41,294.19,417.94,292.57Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 417.94,
    y1: 292.57,
    x2: 410.78,
    y2: 287.01,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 422.54,
    y1: 417.57,
    x2: 426.81,
    y2: 412.14,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.19,414.22a6.77,6.77,0,0,1,1.85-5.3c1.38-1.52,9.07-5.75,10.13-3C438.32,408.92,430.72,415.83,425.19,414.22Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 425.19,
    y1: 414.22,
    x2: 432.77,
    y2: 408.35,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 421.51,
    y1: 371.24,
    x2: 426.81,
    y2: 364.33,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.19,366.4a6.78,6.78,0,0,1,1.85-5.3c1.38-1.52,9.07-5.74,10.13-3C438.32,361.1,430.72,368,425.19,366.4Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 425.19,
    y1: 366.4,
    x2: 432.77,
    y2: 360.53,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 421.51,
    y1: 347.64,
    x2: 426.81,
    y2: 340.73,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.19,342.8a6.78,6.78,0,0,1,1.85-5.3c1.38-1.52,9.07-5.74,10.13-3C438.32,337.5,430.72,344.41,425.19,342.8Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 425.19,
    y1: 342.8,
    x2: 432.77,
    y2: 336.93,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 421.51,
    y1: 316.44,
    x2: 426.81,
    y2: 309.53,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.19,311.61a6.77,6.77,0,0,1,1.85-5.3c1.38-1.52,9.07-5.75,10.13-3C438.32,306.31,430.72,313.22,425.19,311.61Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 425.19,
    y1: 311.61,
    x2: 432.77,
    y2: 305.74,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 421.74,
    y1: 289.52,
    x2: 426.93,
    y2: 285.47,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.19,287.08a6.75,6.75,0,0,1,1.85-5.29c1.38-1.53,9.07-5.75,10.13-3C438.32,281.79,430.72,288.69,425.19,287.08Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 425.19,
    y1: 287.08,
    x2: 432.77,
    y2: 281.21,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.19,276.21a6.79,6.79,0,0,1,1.84-5.3c1.39-1.53,9.08-5.75,10.14-3C434.32,270.91,426.72,277.82,421.19,276.21Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 421.19,
    y1: 276.21,
    x2: 428.77,
    y2: 270.34,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.56,276.53a6.76,6.76,0,0,1-5.07-2.39c-1.37-1.53-4.77-9.62-1.92-10.39C417.67,262.92,423.74,271.2,421.56,276.53Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 421.56,
    y1: 276.53,
    x2: 416.52,
    y2: 268.38,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "428.08 475.42 411.14 475.42 409.02 432.63 430.2 432.63 428.08 475.42",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresspauseBro);
export default __webpack_public_path__ + "static/media/Press pause-bro.b5dc9db0afaab384a5e8c32c2cbadced.svg";
export { ForwardRef as ReactComponent };